<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Usługi</span>
        <h3 class="page-title">
          <template v-if="isEdit">Edycja usługi</template>
          <template v-else>Dodawanie usługi</template>
        </h3>
      </d-col>
      <d-col
        col
        sm="6"
        class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="secondary"
          @click.prevent="$router.push('/usługi')"
          class="mr-1">
          <i class="material-icons">arrow_back</i>
          Wróć do listy
        </d-button>
        <d-button
          theme="success"
          @click.prevent="validateForm">
          Zapisz zmiany
        </d-button>
      </d-col>
    </d-row>
    <!-- Form -->
    <d-form>
      <d-card class="mb-5">
        <d-tabs card
        :nav-class="allDataLoaded ? validationResults : ''"
        :class="{'is-loading': !allDataLoaded}">
          <!-- Dane ogólne -->
          <d-tab title="Dane ogólne" active>
            <h4 class="mb-3 pb-3 border-bottom">
              Dane ogólne
            </h4>
            <validation-observer ref="services-form-general" tag="form">
              <div class="form-group">
                <label for="name">
                  Nazwa:
                </label>
                <validation-provider
                  rules="required"
                  name="name"
                  v-slot="{ errors }">
                  <d-input
                    :class="[(importantName === true && !data.name) ? 'invalid-service' : '']"
                    :state="errors.length ? 'invalid' : null"
                    v-model="data.name" />
                </validation-provider>
                <div class="invalid-feedback-service" style="display: block; margin-top: 0.5rem" v-if="importantName === true && !data.name">
                  To pole jest wymagane
                </div>
              </div>
              <div class="form-group">
                <validation-provider
                  :rules="'required'"
                  :name="'category_id'"
                  v-slot="{ errors }">
                  <div class="form-group" style="margin-bottom: 1.8rem;">
                    <label class="title-box" :for="data.category_id">
                      Kategoria:
                    </label>
                    <v-select
                      :class="['reservation-style', 'reservation-style-select-max', (importantCategory === true && !data.category_id) ? 'invalid-service' : '']"
                      :options="categories"
                      v-model="data.category_id"
                      :reduce="category => category.id"
                      placeholder="Wybierz kategorię"
                      label="id">
                      <template #search="{attributes, events}">
                        <d-input
                          class="input-for-select"
                          :state="errors.length ? 'invalid' : null"
                          :required="!data.category_id"
                          v-bind="attributes"
                          v-on="events"
                        />
                      </template>
                      <template slot="option" slot-scope="option">
                        <div class="d-center">
                          {{ option.name }}
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          {{ option.name }}
                        </div>
                      </template>
                    </v-select>
                  </div>
                </validation-provider>
                <div class="invalid-feedback-service" style="display: block; margin-top: -1.2rem" v-if="importantCategory === true && !data.category_id">
                  To pole jest wymagane
                </div>
              </div>
              <div class="form-group">
                <validation-provider
                  :rules="'required'"
                  :name="'type'"
                  v-slot="{ errors }">
                  <div class="form-group" style="margin-bottom: 1.8rem;">
                    <label class="title-box" :for="data.service_types">
                      Rodzaj usługi:
                    </label>
                    <div :class="{ 'form-control': true, 'is-select': true }">
                      <v-select
                        :class="['reservation-style', 'reservation-style-select-max', (importantType === true && !data.type) ? 'invalid-service' : '']"
                        placeholder="Wybierz rodzaj"
                        :options="serviceType"
                        :reduce="type => type.id"
                        v-model="data.type"
                        label="name">
                        <template #search="{attributes, events}">
                          <d-input
                            class="input-for-select"
                            :state="errors.length ? 'invalid' : null"
                            :required="!data.type"
                            v-bind="attributes"
                            v-on="events"
                          />
                        </template>
                        <template slot="option" slot-scope="option">
                          <div class="d-center">
                            {{ option.name }}
                          </div>
                        </template>
                        <template slot="selected-option" slot-scope="option">
                          <div class="selected d-center">
                            {{ option.name }}
                          </div>
                        </template>
                      </v-select>
                    </div>
                  </div>
                  <div class="invalid-feedback" style="display: block; margin-top: -0.5rem;">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
                <div class="invalid-feedback-service" style="display: block; margin-top: -1.2rem" v-if="importantType === true && !data.type">
                  To pole jest wymagane
                </div>
              </div>
              <div class="form-group">
                <label for="duration">
                 Liczba minut trwania usługi:
                </label>
                <validation-provider
                  rules="required"
                  name="duration"
                  v-slot="{ errors }">
                  <d-select
                    :options="statusFilter"
                    v-model="data.duration"
                    :class="['form-group', 'mr-2', (importantDuration === true && !data.duration) ? 'invalid-service' : '']"
                    :state="errors.length ? 'invalid' : null">
                  </d-select>
                </validation-provider>
                <div class="invalid-feedback-service" style="display: block;" v-if="importantDuration === true && !data.duration">
                  To pole jest wymagane
                </div>
              </div>
              <div class="form-group">
                <validation-provider
                        v-slot="{ errors }">
                  <d-checkbox
                          :state="errors.length ? 'invalid' : null"
                          :checked="String"
                          :value="'1'"
                          :unchecked-value="'0'"
                          v-model="data.is_group"
                  >
                    Warsztaty grupowe
                  </d-checkbox>
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
            </validation-observer>
            <div v-if="!allDataLoaded" class="pb-3 pt-3 text-center">
              Trwa ładowanie danych&hellip;
            </div>
            <d-alert
              v-if="loadError"
              show
              theme="warning">
              Wczytywanie danych nie powiodło się. <a href="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
            </d-alert>
          </d-tab>
          <d-tab title="Placówki">
            <d-row no-gutters class="page-header py-4 mb-2">
              <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
                <h4>Lista placówek: <p class="mt-1 mb-0" style="font-weight: 100">Podaj placówkę, która wykonuje podaną usługę.</p></h4>
              </d-col>
            </d-row>
            <validation-observer ref="services-form-institutions" tag="form">
              <div class="form-group" v-for="(institution, index) in institutionsData" :key="index">
                <div class="form-group">
                  <d-checkbox
                    :value="institution.id"
                    v-model="institutionsId"
                    :class="'mb-3'"
                    toggle>
                    {{ institution.name }}
                  </d-checkbox>
                </div>
              </div>
            </validation-observer>
            <div v-if="!allDataLoaded" class="pb-3 pt-3 text-center">
              Trwa ładowanie danych&hellip;
            </div>
            <d-alert
              v-if="loadError"
              show
              theme="warning">
              Wczytywanie danych nie powiodło się. <a href="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
            </d-alert>
          </d-tab>
          <d-tab title="Lista pracowników">
            <d-row no-gutters class="page-header py-4 mb-2">
              <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
                <h4>Lista pracowników wykonujących usługę: <p class="mt-1 mb-0" style="font-weight: 100; color: #17c671">{{data.name}}</p></h4>
              </d-col>
            </d-row>
            <table class="table mt-0 mb-0 full-width">
              <thead class="bg-light">
              <tr>
                <th scope="col" class="border-0">Imię i nazwisko</th>
                <th scope="col" class="border-0">Adres e-mail</th>
                <th scope="col" class="border-0">Wymiar pracy</th>
                <th scope="col" class="border-0">Edytuj</th>
              </tr>
              </thead>
              <tbody v-if="loaded">
              <tr
                v-for="(users, indexService) in servicesUsers[0]"
                :key="indexService">
                <td class="align-middle">
                  {{users.name}} {{users.last_name}}
                </td>
                <td class="align-middle">
                  {{users.email}}
                </td>
                <td class="align-middle">
                  {{users.employment_typ !== 'E_PART_TIME' ? 'Pełen etat' : 'Pół etatu'}}
                </td>
                <td
                  class="align-middle"
                  style="width: 150px;">
                  <d-button
                    theme="primary"
                    @click.prevent="$router.push('/uzytkownicy/edycja/' + users.id)"
                    class="mr-2"
                    title="Edytuj">
                    <i class="material-icons">edit</i>
                  </d-button>
                </td>
              </tr>
              <tr>
                <td
                  v-if="servicesUsers[0] ? (servicesUsers[0].length === 0) : !servicesUsers[0]"
                  colspan="5"
                  class="text-center">
                  Brak specjalistów do wyświetlenia&hellip;
                </td>
              </tr>
              </tbody>
            </table>
            <div v-if="!services" class="pb-3 pt-3 text-center">
              Trwa ładowanie danych&hellip;
            </div>
            <d-alert
              v-if="loadError"
              show
              theme="warning">
              Wczytywanie danych nie powiodło się. <a href="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
            </d-alert>
          </d-tab>
        </d-tabs>
      </d-card>
    </d-form>
  </d-container>
</template>

<script>
import Vue from 'vue';
import FormUtils from './../../utils/FormUtils.js';
import ListUtils from './../../utils/ListUtils.js';

export default {
  name: 'office-form',
  computed: {
    allDataLoaded () {
      return this.loaded && this.loadedCategories;
    },
    isEdit () {
      return !!this.$route.params.id;
    },
    statusFilter () {
      return ['15:00', '30:00', '45:00', '1:00:00', '1:15:00', '1:30:00', '1:45:00', '2:00:00', '2:15:00', '2:30:00', '2:45:00', '3:00:00',
        '3:15:00', '3:30:00', '3:45:00', '4:00:00', '4:15:00', '4:30:00', '4:45:00', '5:00:00', '5:15:00', '5:30:00', '5:45:00', '6:00:00'];
    },
    validationResults() {
      if (!this.allDataLoaded) {
        return false;
      }

      if (!this.isValidationRequested) {
        return '';
      }

      let rawErrors = this.$refs['services-form-general'].errors;
      let errorKeys = Object.keys(rawErrors);
      let errors = [];

      for (let i = 0; i < errorKeys.length; i++) {
        if (rawErrors[errorKeys[i]].length) {
          errors.push(errorKeys[i]);
        }
      }

      let errorTabs = [];

      if (errors.find(item => ['name', 'category_id', 'type', 'duration'].includes(item))) {
        errorTabs.push('error-1');
      }

      return errorTabs.join(' ');
    },
  },
  data() {
    return {
      data: {
        name: '',
        id: '',
        type: '',
        category_id: '',
        institutions: [],
        duration: '',
        is_group: '0'
      },
      loaded: false,
      loadError: false,
      categories: [],
      serviceType: [],
      institutionsData: [],
      institutionsId: [],
      institutionsArr: [],
      services: [],
      servicesUsers: [],
      loadedCategories: false,
      importantCategory: false,
      importantType: false,
      importantName: false,
      importantDuration: false,
      isValidationRequested: false
    };
  },
  mounted () {
    if (this.isEdit) {
      this.loadItemData();
      this.loadServicesData();
    } else {
      this.loaded = true;
    }

    this.loadAdditionalData();
    this.getServiceType();
    setTimeout(() => {
      this.getInstitutionsList();
      setTimeout(() => {
        this.dataInstitutionsId();
      }, 500);
    }, 400);
  },
  watch: {
    'institutionsId': function (value) {
      if (value.length) {
        this.comparisonInstitutionsId();
      }
    },
    'institutionsData': function (value) {
      if (value.length) {
        this.comparisonInstitutionsId();
      }
    },
    'services': function (value) {
      if (value.length) {
        this.dataServicesUsers()
      }
    }
  },
  methods: {
    getServiceType () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/services/types',
        outputKey: 'serviceType',
      });
    },
    loadServicesData () {
      ListUtils.loadItemsData(this, {
        endpoint: '/services/items',
        listField: 'services',
        params: {
          pagination: false
        },
      });
    },
    dataInstitutionsId () {
      const data = this.data.institutions;
      let institutionsId = [];
      for (let i = 0; i < data.length; i++) {
        institutionsId[i] = data[i].id
      }
      this.institutionsId = institutionsId;
    },
    dataServicesUsers () {
      const services = this.services;
      const checkId = this.data.id;
      let users = [];
      for (let i = 0; i < services.length; i++) {
        if (checkId === services[i].id) {
          users[i] = services[i].users;
        }
      }
      this.servicesUsers = users.filter(n => n);
    },
    comparisonInstitutionsId () {
      const institutions = JSON.parse(JSON.stringify(this.institutionsData));
      const checkId = JSON.parse(JSON.stringify(this.institutionsId));
      let checkboxArr = [];
      for (let i = 0; i < institutions.length; i++) {
        for (let j = 0; j < checkId.length; j++) {
          if (checkId[j] === institutions[i].id) {
            checkboxArr[i] = institutions[i]
          }
        }
      }
      this.institutionsArr = checkboxArr;
    },
    getInstitutionsList () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/institutions/items?ignore_users_filters=1',
        outputKey: 'institutionsData',
        params: {
          pagination: false
        },
      });
    },
    loadItemData () {
      FormUtils.loadItemData(this, {
        endpointBase: '/services/item/',
        instanceFields: ['name', 'category_id', 'duration', 'institutions', 'id', 'type', 'is_group'],
        loadedKey: 'loaded'
      });
    },
    loadAdditionalData () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/services/categories/items',
        params: {
          pagination: false
        },
        outputKey: 'categories',
        loadedKey: 'loadedCategories',
        errorKey: 'loadError',
      });
    },
    validateForm () {
      this.importantDuration = true;
      this.importantCategory = true;
      this.importantName = true;
      this.importantType = true;
      Vue.set(this, 'isValidationRequested', true);
      if (this.data.duration && this.data.name && this.data.category_id) {
        FormUtils.validate(this.$refs['services-form-general'], this.submitForm);
      } else {
        FormUtils.validate(this.$refs['services-form-general']);
      }
    },
    submitForm () {
      let formDataToSend = this.prepareFormDataToSend();
      let endpointUrl = this.isEdit ? '/services/update/' + this.data.id : '/services/store';

      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: 'Zapisano usługę',
        successText: 'Wybrana usługa została zapisana',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Modyfikacje usługi nie powiodły się. Spróbuj ponownie.',
        successAction: () => {
          this.$router.push('/usługi')
        }
      });
    },
    prepareFormDataToSend () {
      return {
        name: this.data.name,
        category_id: this.data.category_id,
        type: this.data.type,
        duration: this.data.duration,
        institutions: this.institutionsArr.filter(n => n),
        is_group: this.data.is_group
      };
    },

  }
};
</script>
<style scoped lang="scss">
  .subtitle-text {
    display: block;
    font-size: 15px;
    font-weight: 100;
  }
  .invalid-service {
    outline: none;
    border-color: #c4183c;
    box-shadow: 0 5px 11.5px rgba(196, 24, 60, 0.1);
    input, label {
      border-color: #c4183c;
      box-shadow: 0 5px 11.5px rgba(196, 24, 60, 0.1);
      outline: none;
      &:focus {
        outline: none;
      }
      &:active {
        outline: none;
      }
    }
    .mx-icon-calendar {
      color: #c4183c;
    }
  }
  .invalid-feedback-service {
    margin-top: -0.65rem;
    font-size: 80%;
    color: #c4183c;
  }
  .vs__dropdown-option {
    white-space: normal;
  }
</style>
